import PopularSearchItems from "component/popularSearchItems/PopularSearchItems";
import TopSearches from "component/topSearches/TopSearches";
import { Globalstate } from "context/context";
import React from "react";
import clockHistoryIcon from "../../assets/photos/clock-history-icon.svg";
import "../prompts/prompts.css";

const RecentSearches = ({ handleSubmit }) => {
  const { state } = Globalstate();
  return (
    <div className="homepage-search-recent">
      <div className="previous-searches">
        <div className="searches">
          {state.recentSearches.map((item, i) => {
            return (
              <div
                className="searches-item"
                key={i}
                onClick={() => handleSubmit(item)}
              >
                <img src={clockHistoryIcon} alt="" />
                <p>{item}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecentSearches;
